module.exports = __webpack_public_path__ + "img/SES_38037460.4f332ccb.jpg";